export default __webpack_public_path__ + "alberta-copy-url.59e0c83a61bd26097181.svg";